class CoinPullReportPrintController {
  /*@ngInject*/
  constructor(Auth, $state, Modal, $translate, $stateParams, RouteService, User) {
    this.Modal = Modal
    this.Auth = Auth
    this.$state = $state
    this.$translate = $translate
    this.$stateParams = $stateParams
    this.RouteService = RouteService
    this.User = User
    this.id = 'print'

    this.model = {
      branch: this.$stateParams.branch || this.User.getUser().branchId
    };
    this.coinReportData = [];
  }

  $onInit() {
    if (window.opener && window.opener.w && window.opener.w.printData && window.opener.w.printData.doPrint) {
      this.model = window.opener.w.printData.model
      this.coinReportData = window.opener.w.printData.coinReportData
      this.showReport = true

      setTimeout(() => {
        window.print()
      }, 1000)
    }
    else if (this.$stateParams.route && this.$stateParams.date) {
      const route = this.$stateParams.route;
      const date = this.$stateParams.date;
      this.loading = true;

      this
        .RouteService
        .coinPullReport(route, moment(date).format('YYYY-MM-DD'))
        .then((data) => {
          // console.log(data);
          data.forEach(function (row) {
            let coins = angular.copy(row)
            delete coins.address
            delete coins.city
            delete coins.fromLocationId
            delete coins.name

            row.coins = coins
          })

          this.coinReportData = data;

          let coinKeys = [];
          if (this.coinReportData.length > 0 && this.coinReportData[0].coins) {
            const keys = Object.keys(this.coinReportData[0].coins);
            coinKeys = keys;
          }

          this.coinReportData = data.map((branchReport) => {
            let total = 0;

            coinKeys.forEach((coinKey) => {
              total += branchReport[coinKey];
            });

            branchReport.total = total;
            return branchReport;
          })
            .filter((branchReport) => {
              return branchReport.total > 0;
            });

          this.showReport = true;

          setTimeout(() => {
            window.print()
          }, 1000)
        })
        .catch((err) => {
          console.log('Some error', err)
        })
        .finally(() => {
          const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

          this.loading = false;
          this.model.route = route;
          this.model.date = date;
          this.model.day = days[moment(this.model.date).day()];

        });
    }

  }
}

export default CoinPullReportPrintController;


// WEBPACK FOOTER //
// ./client/app/components/coin_pull_report/print_route_coin/coin_pull_report_print.controller.js